import {gql} from '@apollo/client';
import {DocumentNode} from 'graphql';

export const ORGANIZATION_DEFAULT_SCHEMA_COLLABORATORS_CONFIGURATION_FRAGMENT: DocumentNode = gql`
  fragment OrganizationDefaultSchemaCollaboratorsConfiguration on OrganizationNode {
    id
    handle
    name
    schemaCollaborationDefaultConfigurations {
      id
      schemaType
      defaultSchemaCollaborations {
        party {
          ... on PartyInterface {
            id
            name
            handle
          }
        }
        policy {
          id
        }
        teamRole
        organizationRole
      }
    }
  }
`;
